import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { FiguresBox } from '../components/FiguresBox/FiguresBox';
import LocalTexts from '../Payments.text.json';

const LocalT = new MDText(LocalTexts.payments.softError);

const PaymentSoftError = () => (
  <div>
    <FiguresBox
      buttons={
        <Button
          fullWidth
          reverse
          as="a"
          href="tel:123123123"
          icon="phone"
          label="{Phone number}"
        />
      }
      content={
        <>
          {[1, 2].map((item: number) => (
            <p>{`${LocalT.translate(`desc${item}`)}`}</p>
          ))}
        </>
      }
      icon='info'
      title={`${LocalT.translate('title')}`}
    />
  </div>
);

export { PaymentSoftError };
